import {
  createErrorType,
  createFetchType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
  createUpdateType,
} from '../actionHelpers';

// Get Custodians List
export const GET_CUSTODIANS_SCOPE = 'GET_CUSTODIANS_SCOPE';
export const GET_CUSTODIANS = createFetchType(GET_CUSTODIANS_SCOPE);
export const GET_CUSTODIANS_SUCCESS = createSuccessType(GET_CUSTODIANS_SCOPE);
export const GET_CUSTODIANS_ERROR = createErrorType(GET_CUSTODIANS_SCOPE);
export const GET_CUSTODIANS_LOADING = createLoadingType(GET_CUSTODIANS_SCOPE);

// Create Custodian
export const CREATE_CUSTODIAN_SCOPE = 'CREATE_CUSTODIAN_SCOPE';
export const CREATE_CUSTODIAN = createSubmitType(CREATE_CUSTODIAN_SCOPE);
export const CREATE_CUSTODIAN_SUCCESS = createSuccessType(
  CREATE_CUSTODIAN_SCOPE,
);
export const CREATE_CUSTODIAN_ERROR = createErrorType(CREATE_CUSTODIAN_SCOPE);
export const CREATE_CUSTODIAN_LOADING = createLoadingType(
  CREATE_CUSTODIAN_SCOPE,
);

// Update Custodian
export const UPDATE_CUSTODIAN_SCOPE = 'UPDATE_CUSTODIAN_SCOPE';
export const UPDATE_CUSTODIAN = createUpdateType(UPDATE_CUSTODIAN_SCOPE);
export const UPDATE_CUSTODIAN_SUCCESS = createSuccessType(
  UPDATE_CUSTODIAN_SCOPE,
);
export const UPDATE_CUSTODIAN_ERROR = createErrorType(UPDATE_CUSTODIAN_SCOPE);
export const UPDATE_CUSTODIAN_LOADING = createLoadingType(
  UPDATE_CUSTODIAN_SCOPE,
);
